import { media } from 'styled-bootstrap-grid'
import styled, { css } from 'styled-components'
import oseanShape from 'assets/images/ocean-shape.png'
import { HeaderBackgroundProps } from './HeaderBackground'

const backgroundImage = css`
  position: absolute;
  overflow: hidden;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
`

export const BackgroundWrapper = styled.div<HeaderBackgroundProps>`
  ${({ defaultImageUrl }) =>
    defaultImageUrl &&
    `
    background-image: url(${defaultImageUrl});
    ${backgroundImage}
  `}
`

export const Background = styled.div<HeaderBackgroundProps>`
  ${({ imageUrl }) =>
    imageUrl &&
    `
    z-index: 1;
    background-image: url(${imageUrl});
    ${backgroundImage}
  `}

  &:after {
    content: '';
    position: absolute;
    z-index: 2;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.3);
  }

  &:before {
    content: '';
    position: absolute;
    z-index: 3;
    top: 55px;
    left: 50%;
    width: 407px;
    height: 413px;
    background-image: url(${oseanShape});
    background-size: 100%;
  }

  ${media.sm`
    &:before {
      width: 780px;
      height: 780px;
    }
  `}
`
